const Lang = require('lang');
const GlobalAlerts = require('./GlobalAlerts');
const MakeInfiniteScrollOnEach = require('./MakeInfiniteScrollOnEach.js')

/**
 * Apenas se for clicado no botão de enviar
 * Diferente do código MakeInfiniteScrollOnEach, preciso que só
 * rode quando o botão de Filtrar for clicado
 */
function HorusRelatorioGerencial() {
  const observer = containerObserver();

  $('button[data-button-submit]').on('click', function () {
    const $el = $('[data-infinite-scroll]');
    const $container = $el.find('[data-infinite-scroll-content]');
    const $loading = $el.find('[data-infinite-scroll-loading]');
    const $empty = $el.find('[data-infinite-scroll-empty]');
    const dados = getDados();
    // Esconde os elementos de loading e vazio
    $empty.hide();
    $container.hide();
    $loading.show();

    killInfiniteScroll();
    getHorus(
      dados,
      function (result) {
        firstScroll($container, result)
        MakeInfiniteScrollOnEach.init(true, 'POST', dados);
      },
      function (err) {
        GlobalAlerts.createAndShow({
          type: 'danger',
          title: Lang.get('js/src/functions/HorusRelatorioGerencial.ops'),
          message: err.responseJSON.message
        });
        $empty.show();
        $loading.hide();
      }
    );
  })

  $(document).on('click', '.pagination li a', function (event) {
    event.preventDefault();
    const $container = $('#restrictive-tags');
    const dados = getDados();
    getHorusOnlyTags(dados, event.target.href, $container)
  });
}

/**
 * Função assíncrona para requisição do horus
 * @param  {object}   dados
 * @param  {Function} cb
 * @param  {Function} errorCb
 */
function getHorus(dados, cb, errorCb) {
  $.ajax({
    type: 'POST',
    url: route('app.admin.post-relatorio-horus') + '?' + $.param({ 'page': 1 }),
    data: dados,
    success: cb,
    error: errorCb,
  });
}

/**
 * Função assíncrona para requisição do horus
 * @param  {object} dados
 * @param  {string} url
 * @param  {object} container
 */
function getHorusOnlyTags(dados, url, container) {
  $.ajax({
    type: 'GET',
    url: url,
    data: dados,
  })
    .done(data => {
      const $data = $('<div id="restrictive-tags-content">' + data + '</div>');
      container.find('#restrictive-tags-content').replaceWith($data);
    })
    .fail((response) => {
      GlobalAlerts.createAndShow({
        type: 'danger',
        title: Lang.get('js/common/phrases.ops'),
        message: Lang.get('js/common/phrases.unexpected_error'),
      });
    });
}

/**
 * Construção da primeira página
 * @param  {object} $container
 * @param  {string} result
 */
function firstScroll($container, result) {
  $container.html(result).show();

  const $el = $('[data-infinite-scroll]');
  const $loading = $el.find('[data-infinite-scroll-loading]');
  $loading.hide();

  const $empty = $el.find('[data-infinite-scroll-empty]');
  $empty.hide();

  // // Garante que se não veio conteúdo, exibe vazio
  if ($container.children().length === 0) {
    $('[data-infinite-scroll-empty]').show();
  }
}

/**
 * Checa se ouve mudança no conteúdo do infinite scroll
 * @return  {MutationObserver}
 */
function containerObserver() {
  const config = { attributes: true, childList: true, subtree: true };
  const $el = $('[data-infinite-scroll]');
  const $container = $el.find('[data-infinite-scroll-content]');
  const $loading = $el.find('[data-infinite-scroll-loading]');
  const $empty = $el.find('[data-infinite-scroll-empty]');
  const observer = new MutationObserver(function () {
    groupTitle($el);
    if (
      $container.length > 0
      && $loading.css('display') === 'none'
    ) {
      $empty.show();
      $container.show();
      // Mata o observer
      observer.disconnect();
    }
  });

  if ($container.length) {
    observer.observe($container[0], config);
  }
}

/**
 * Preenche o título por grupo de despesas
 * @param  {object} $el
 */
function groupTitle($el) {
  const group = $el.find('[data-group-title]');
  const duplicate = Lang.get('js/common/table/th.duplicate');
  const duplicateAndTag = Lang.get('js/common/table/th.duplicate_and_tags');

  for (let i = group.length - 1; i >= 0; i--) {
    let message = duplicate;
    if (group[i].dataset.hasTags) {
      message = duplicateAndTag;
    }
    group[i].text = `${message} ${i + 1}`;
    if (group.length - i == 15) {
      break;
    }
  }
}

/**
 * Mata a função de infinite scroll da pesquisa anterior
 */
function killInfiniteScroll() {
  $(document).off('scroll touchmove');
}

/**
 * monta o objeto de dados utilizado em cada request do relatório
 */
function getDados() {
  const $inputs = $('#collapseOne').find('input, select');
  const dados = {};

  $inputs.each(function () {
    if (this.id) {
      if ($(this).val()) {
        dados[this.id] = $(this).val();
      }
    }
  });

  return dados;
}

module.exports = {
  init: HorusRelatorioGerencial,
  url: /\/admin\/relatorio-horus*/
}
